import React, { useEffect, useState } from "react";
import { Img } from "react-image";
import "./Navbar.scss"

import ConfirmationModal from "../../../../../Components/ConfirmationBox/ConfirmationModal";
import CompanyProfileModal from "../CompanyProfile/EditCompanyProfile/CompanyProfileEdit";
import AdminProfileModal from "../AdminProfile/AdminProfileModal/AdminProfileModal";
import TruckAdminProfileModal from "../TruckAdminProfile/TruckAdminProfileModal/TruckAdminProfileModal";

import downArrow from "../../../../../Assets/images/down-arrow.svg";
import trackIcon from "../../../../../Assets/images/track-icon.png"

import { logout } from "../../../Config/Auth";
import { useAdminProfile } from "../../Context/AdminProfileImage/AdminProfileImage";
import { useSidebar } from "../../Context/SidebarContext/SidebarContext";
import apiClient from "../../../../../Config/apiClient";

const adminPath = process.env.REACT_APP_TC_ADMIN_BASE_PATH

const Navbar = () => {
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showCompanyProfileModal, setShowCompanyProfileModal] = useState(false);
    const [showAdminProfileModal, setShowAdminProfileModal] = useState(false);

    const { activeTab, activeSubTab } = useSidebar();
    const { profileImageUrl } = useAdminProfile();

    const [adminData, setAdminData] = useState({
        first_name: "",
        last_name: "",
        email_id: "",
        user_role: "",
        profile_image_file: null,
    });

    useEffect(() => {
        const fetchAdminProfile = async () => {
            try {
                const response = await apiClient.get(`${adminPath}/profile`);
                if (response?.data?.status === "SUCCESS") {
                    setAdminData(response.data.data);
                }
            } catch (err) {
                console.error("Failed to fetch admin profile:", err);
            }
        };

        fetchAdminProfile();
    }, [showAdminProfileModal]);

    const handleLogout = (e) => {
        e.preventDefault();
        setShowLogoutModal(true);
    };

    const confirmLogout = () => {
        setShowLogoutModal(false);
        logout();
    };

    const { first_name, last_name, email_id, user_role } = adminData;
    const fullName = `${first_name} ${last_name}`.trim();
    const initials = `${first_name?.[0] || ""}${last_name?.[0] || ""}`.toUpperCase();

    return (
        <header>
            <div className="main-header">
                <div className="mh-inner">
                    <div className="mh-left">
                        <h1>{activeSubTab ? `${activeTab} - ${activeSubTab}` : activeTab}</h1>
                    </div>
                    <div className="mh-right">
                        <div className="dropdown-cvr">
                            <div className="dropdown">
                                <button className="dropdown-toggle drp-button" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                    <div className="drop-image">
                                        {profileImageUrl ? (
                                            <Img
                                                src={profileImageUrl}
                                                alt="Admin"
                                                loader={<div className="initials-circle">{initials}</div>}
                                                unloader={<div className="initials-circle">{initials}</div>}
                                            />
                                        ) : (
                                            <div className="initials-circle">{initials}</div>
                                        )}
                                    </div>

                                    <img className="da-icon" src={downArrow} alt="Dropdown arrow" />
                                </button>

                                <ul className="dropdown-menu profile-drop" aria-labelledby="dropdownMenuButton1">
                                    <div className="pd-top">
                                        <h3>{fullName}</h3>
                                        <p>{email_id}</p>
                                    </div>

                                    <li>
                                        <a className="drop-link" href="#" onClick={(e) => { e.preventDefault(); setShowAdminProfileModal(true); }}  >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="14.867" height="16.475" viewBox="0 0 14.867 16.475">
                                                <g transform="translate(-3 -2)">
                                                    <path d="M11.021,11.042A4.021,4.021,0,1,0,7,7.021,4.021,4.021,0,0,0,11.021,11.042Z" transform="translate(-0.587)" fill="none" stroke="#5e5e5e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                    <path d="M16.867,19.433A6.433,6.433,0,1,0,4,19.433" transform="translate(0 -1.958)" fill="none" stroke="#5e5e5e" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                                </g>
                                            </svg>
                                            Profile
                                        </a>
                                    </li>

                                    <li>
                                        <a className="drop-link" href="#" onClick={(e) => { e.preventDefault(); setShowCompanyProfileModal(true); }} >
                                            <svg xmlns="http://www.w3.org/2000/svg" width="15.333" height="13.8" viewBox="0 0 15.333 13.8">
                                                <path d="M14.267,12.2H12.733v1.533h1.533m0-4.6H12.733v1.533h1.533m1.533,4.6H9.667V13.733H11.2V12.2H9.667V10.667H11.2V9.133H9.667V7.6H15.8M8.133,6.067H6.6V4.533H8.133m0,4.6H6.6V7.6H8.133m0,4.6H6.6V10.667H8.133m0,4.6H6.6V13.733H8.133M5.067,6.067H3.533V4.533H5.067m0,4.6H3.533V7.6H5.067m0,4.6H3.533V10.667H5.067m0,4.6H3.533V13.733H5.067m4.6-7.667V3H2V16.8H17.333V6.067Z" transform="translate(-2 -3)" fill="#5e5e5e" />
                                            </svg>
                                            Company Profile
                                        </a>
                                    </li>

                                    <li>
                                        <a onClick={handleLogout} className="drop-link br-none" href="#">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="19.826" height="21.799" viewBox="0 0 19.826 21.799">
                                                <path d="M7.023,5.5a9,9,0,1,0,9.953,0M12,2v8" transform="translate(-2.086 -1.1)" fill="none" stroke="#111" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8" />
                                            </svg>
                                            Log Out
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showLogoutModal && (
                <ConfirmationModal
                    id="logoutModal"
                    show={showLogoutModal}
                    title="Confirm Logout"
                    message="Are you sure you want to log out?"
                    confirmText="Yes"
                    cancelText="No"
                    onConfirm={confirmLogout}
                    onCancel={() => setShowLogoutModal(false)} />
            )}

            {showCompanyProfileModal && (
                <CompanyProfileModal onClose={() => setShowCompanyProfileModal(false)} />
            )}

            {showAdminProfileModal && (
                <>
                    {adminData?.user_role === "Truck-Admin" ? (
                        <TruckAdminProfileModal onClose={() => setShowAdminProfileModal(false)} />
                    ) : (
                        <AdminProfileModal onClose={() => setShowAdminProfileModal(false)} />
                    )}
                </>
            )}

        </header>
    );
};

export default Navbar;
